import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { EXONN_HUB_FILTERS_PANEL_Z_INDEX } from "src/admin/modules/b2b-gate-order/components/ExonnHub/ExonnHub.constants.ts";

export const body = (theme: ExactTheme) => css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
  overflow: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 15px;
`;

export const root = (theme: ExactTheme) => css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 15px;
  padding-top: 15px;
  padding-bottom: 15px;

  // padding-right is not set here
  // I did it on purpose.
  // to press scrollbar to the right edge of the sidebar
  height: 100%;
  background-color: ${theme.colorsV2.white};
  border-right: 1px solid ${theme.colorsV2.grey[100]};

  @media ${theme.device.desktop} {
    border-right: none;
    border-radius: 6px;
    border: 1px solid ${theme.colorsV2.grey[100]};
  }
`;

export const outer =
  ({ isOpen }: { isOpen: boolean }) =>
  (theme: ExactTheme) => css`
    width: 234px;

    height: 100%;
    position: relative;

    flex-shrink: 0;
    z-index: ${EXONN_HUB_FILTERS_PANEL_Z_INDEX};

    //box-shadow: ${theme.shadowV2.secondary};

    @media ${theme.device.mobileS} {
      display: ${isOpen ? "block" : "none"};
    }

    @media ${theme.device.laptopL} {
      display: block;
      width: 270px;
      //width: 293px;
    }

    @media ${theme.device.desktop} {
      display: block;
      width: 303px;
      padding-left: 15px;
      padding-top: 15px;
      padding-bottom: 15px;
    }
  `;
